<div class="d-flex">
  <div class="w-100">
    <h3>Slots</h3>
    <div style="height: 400px;overflow: auto;border: black 1px solid">
      <table class="table table-hover">
        <tbody>
        <tr class="cursor-pointer" *ngFor="let slot of slots" (click)="addToFallback(slot)">
          <td>
            <div class="d-flex">
              <div>{{slot.orderNum + 1}}</div>
              <div *ngIf="slot?.name">:
                <span [innerHTML]="slot?.name|truncate:15"></span>
              </div>
            </div>
          </td>
          <td class="tr">
            <sb-icon icon="plus" class="green"></sb-icon>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="mx-4 d-flex justify-content-center align-items-center">>>
  </div>
  <div class="w-100">
    <h3>Fallback</h3>
    <div style="height: 400px;overflow: auto;border: black 1px solid">
      <table class="table">
        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
        <tr *ngFor="let slot of fallback, index as index" class="cursor-pointer" cdkDrag cdkDragLockAxis="y">
          <td cdkDragHandle>
            <div class="d-flex">
              <div><span class="font-weight-bold">Fallback {{index + 1}}:</span> Slot #{{slot.orderNum + 1}}</div>
              <div *ngIf="slot?.name">&nbsp;(<span [innerHTML]="slot?.name|truncate:15"></span>)
              </div>
            </div>
          </td>
          <td class="tr">
            <sb-icon icon="drag" class="blue mr-2" cdkDragHandle></sb-icon>
            <sb-icon icon="minus" class="red" (click)="removeFromFallback(slot)"></sb-icon>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="d-flex justify-content-between mt-2">
  <button type="button" class="btn btn-danger" (click)="cancelFallback()">{{'lang.globals.cancel'|translate}}</button>
  <button type="button" class="btn btn-primary" (click)="submitFallback()">{{'lang.globals.submit'|translate}}</button>
</div>
